export const MODULES = ["FIN", "SCM", "PPM", "ADM", "HR", "Procurement", "Inventory"];
export const PRIORITIES = ["Critical", "High", "Medium", "Low"];
export const OBJECT_TYPES = ["Configuration", "Report", "Interface", "Workflow", "Screen", "API Spec", "Integration", "Other"];
export const BRD_STATUSES = ["Available", "Not Available"];
export const FDD_READY = ["Yes", "No", "In Progress", "N/A"];
export const SIT_STATUSES = ["Not Started", "In Progress", "Completed"];
export const UAT_STATUSES = ["Not Started", "In Progress", "UAT", "Completed"];
export const PROD_MIGRATION_STATUSES = ["Not Started", "In Progress", "Completed"];
export const DEV_STATUSES = ["Not Started", "In Progress", "On Hold", "UAT", "Completed"];
export const OVERALL_STATUSES = ["Not Started", "On Track", "At Risk", "Critical", "Hold", "Completed"];
export const RISK_LEVELS = ["Low", "Medium", "High", "Critical"];

// Status color mapping for badges
export const STATUS_COLOR = {
  "Not Started": "bg-neutral-100 text-neutral-700 border-neutral-200",
  "In Progress": "bg-sky-50 text-sky-700 border-sky-200",
  "On Track": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "At Risk": "bg-amber-50 text-amber-700 border-amber-200",
  Critical: "bg-red-50 text-red-700 border-red-200",
  Hold: "bg-neutral-100 text-neutral-700 border-neutral-200",
  "On Hold": "bg-neutral-100 text-neutral-700 border-neutral-200",
  UAT: "bg-violet-50 text-violet-700 border-violet-200",
  Completed: "bg-indigo-50 text-indigo-700 border-indigo-200",
  Available: "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Not Available": "bg-red-50 text-red-700 border-red-200",
  Yes: "bg-emerald-50 text-emerald-700 border-emerald-200",
  No: "bg-red-50 text-red-700 border-red-200",
  "N/A": "bg-neutral-100 text-neutral-700 border-neutral-200",
  High: "bg-orange-50 text-orange-700 border-orange-200",
  Medium: "bg-amber-50 text-amber-700 border-amber-200",
  Low: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export const TASK_COLUMNS = [
  { key: "module", label: "Module", sticky: true, minWidth: 90 },
  { key: "object_id", label: "Object ID", sticky: true, minWidth: 110 },
  { key: "title", label: "Title", minWidth: 220 },
  { key: "object_name", label: "Object Name", minWidth: 140 },
  { key: "object_type", label: "Object Type", minWidth: 130 },
  { key: "priority", label: "Priority", type: "badge", minWidth: 100 },
  { key: "overall_status", label: "Overall Status", type: "badge", minWidth: 130 },
  { key: "completion_pct", label: "Completion %", type: "progress", minWidth: 130 },
  { key: "development_status", label: "Dev Status", type: "badge", minWidth: 130 },
  { key: "risk_level", label: "Risk", type: "badge", minWidth: 100 },
  { key: "delay_days", label: "Delay (Days)", minWidth: 100 },
  { key: "functional_owner", label: "Functional Owner", minWidth: 150 },
  { key: "technical_resource", label: "Tech Resource", minWidth: 150 },
  { key: "resource", label: "Resource", minWidth: 130 },
  { key: "brd_status", label: "BRD Status", type: "badge", minWidth: 130 },
  { key: "brd_date", label: "BRD Date", type: "date", minWidth: 110 },
  { key: "fdd_ready", label: "FDD Ready", type: "badge", minWidth: 110 },
  { key: "fdd_released_date", label: "FDD Released", type: "date", minWidth: 120 },
  { key: "fdd_signoff_date", label: "FDD Sign Off", type: "date", minWidth: 120 },
  { key: "sit_status", label: "SIT Status", type: "badge", minWidth: 120 },
  { key: "sit_completion_date", label: "SIT Completion", type: "date", minWidth: 130 },
  { key: "uat_status", label: "UAT Status", type: "badge", minWidth: 120 },
  { key: "uat_completion_date", label: "UAT Completion", type: "date", minWidth: 130 },
  { key: "prod_migration", label: "Prod Migration", type: "badge", minWidth: 140 },
  { key: "prod_migration_date", label: "Prod Migration Date", type: "date", minWidth: 150 },
  { key: "planned_dev_days", label: "Planned Days", minWidth: 120 },
  { key: "dev_start_date", label: "Dev Start", type: "date", minWidth: 110 },
  { key: "dev_end_date", label: "Dev End", type: "date", minWidth: 110 },
  { key: "target_date", label: "Target Date", type: "date", minWidth: 110 },
  { key: "actual_start_date", label: "Actual Start", type: "date", minWidth: 110 },
  { key: "actual_end_date", label: "Actual End", type: "date", minWidth: 110 },
  { key: "risk_description", label: "Risk Description", minWidth: 220 },
  { key: "scope_of_works", label: "Scope of Works", minWidth: 260 },
  { key: "object_desc", label: "Object Desc", minWidth: 220 },
  { key: "comments", label: "Comments", minWidth: 240 },
  { key: "updated_by", label: "Updated By", minWidth: 160 },
  { key: "updated_at", label: "Updated At", type: "datetime", minWidth: 170 },
];
